/**
 * Currencies supported by our system.
 * For convenience, values should follow Stripe's currencies (https://stripe.com/docs/currencies).
 */
import { assertUnreachable } from '../../shared/assertUnreachable';
/**
 * All supported currencies in For The Record
 *  NOTE: Upgrade StripeSettlementAmountCalculator.ts and StripePaymentGateway.ts when updating this list.
 */
export var Currency;
(function (Currency) {
    Currency["CAD"] = "cad";
    Currency["USD"] = "usd";
    Currency["GBP"] = "gbp";
    Currency["AUD"] = "aud";
})(Currency || (Currency = {}));
/**
 * For every <code>Currency</code>, define a symbol for that currency
 */
export var CurrencySymbol;
(function (CurrencySymbol) {
    CurrencySymbol["CAD"] = "$";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    CurrencySymbol["USD"] = "$";
    CurrencySymbol["GBP"] = "\u00A3";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    CurrencySymbol["AUD"] = "$";
})(CurrencySymbol || (CurrencySymbol = {}));
/**
 * A name mapping for the currency
 */
export var CurrencyName;
(function (CurrencyName) {
    CurrencyName["CAD"] = "Canadian Dollar";
    CurrencyName["USD"] = "US Dollar";
    CurrencyName["GBP"] = "Pound Sterling";
    CurrencyName["AUD"] = "Australian Dollar";
    CurrencyName["EMPTY"] = "";
})(CurrencyName || (CurrencyName = {}));
export class CurrencyUtils {
    static getCurrencySymbol(currency) {
        if (!currency) {
            return CurrencySymbol.USD;
        }
        switch (currency) {
            case Currency.CAD:
                return CurrencySymbol.CAD;
            case Currency.USD:
                return CurrencySymbol.USD;
            case Currency.GBP:
                return CurrencySymbol.GBP;
            case Currency.AUD:
                return CurrencySymbol.AUD;
            default:
                return assertUnreachable(currency);
        }
    }
    /**
     * A friendly name for the currency
     * @param currency
     */
    static getCurrencyName(currency) {
        if (!currency) {
            return CurrencyName.EMPTY;
        }
        switch (currency) {
            case Currency.CAD:
                return CurrencyName.CAD;
            case Currency.USD:
                return CurrencyName.USD;
            case Currency.GBP:
                return CurrencyName.GBP;
            case Currency.AUD:
                return CurrencyName.AUD;
            default:
                return assertUnreachable(currency);
        }
    }
}
